import {
    Configuration,
    BusinessReferralApi,
    BusinessReferralAdminApi,
    EligibilityApi,
    EligibilityCountriesApi,
    EligibilityClientApi,
    EligibilityFreelancerApi,
    EligibilityManagersApi,
    EligibilityProjectApi,
    EligibilityReferrerApi,
    RegistriesApi,
    SubmissionsApi,
} from '@api';

const configuration = new Configuration({basePath: ''});

export const businessReferralsEndpoints = new BusinessReferralApi(configuration);
export const businessReferralsAdminEndpoints = new BusinessReferralAdminApi(configuration);
export const registriesApi = new RegistriesApi(configuration);
export const submissionApi = new SubmissionsApi(configuration);
export const eligibilityApi = new EligibilityApi(configuration);
export const eligibilityCountriesApi = new EligibilityCountriesApi(configuration);
export const eligilibityManagersApi = new EligibilityManagersApi(configuration);
export const eligibilityReferrerApi = new EligibilityReferrerApi(configuration);
export const eligibilityProjectApi = new EligibilityProjectApi(configuration);
export const eligibilityClientApi = new EligibilityClientApi(configuration);
export const eligibilityFreelancerApi = new EligibilityFreelancerApi(configuration);
